import React from 'react';
import PropTypes from 'prop-types';
import { SortableContext, horizontalListSortingStrategy } from '@dnd-kit/sortable';
import DraggableCell from '../DraggableCell';

const TableBody = ({ table, tableVisibleColsKey, emptyMessage }) => {
  const sortableItems = React.useMemo(() => table.getVisibleLeafColumns().map(c => c.id), [tableVisibleColsKey]);

  return (
    <tbody className="NewBaseTable__body">
      {!table.getRowModel().rows.length && emptyMessage && (
        <tr>
          <td colSpan={Math.max(1, table.getVisibleLeafColumns().length)} style={{ padding: 32, textAlign: 'center' }}>
            {emptyMessage}
          </td>
        </tr>
      )}
      {table.getRowModel().rows.map(row => (
        <tr className="NewBaseTable__row" key={row.id}>
          <SortableContext items={sortableItems} strategy={horizontalListSortingStrategy}>
            {row.getVisibleCells().map(cell => (
              <DraggableCell key={cell.id} tableVisibleColsKey={tableVisibleColsKey} cell={cell} />
            ))}
          </SortableContext>
        </tr>
      ))}
    </tbody>
  );
};

TableBody.propTypes = {
  emptyMessage: PropTypes.node,
  table: PropTypes.object.isRequired,
  tableVisibleColsKey: PropTypes.string.isRequired,
};

TableBody.defaultProps = { emptyMessage: null };

export default TableBody;
